module.exports = __webpack_public_path__ + "DINNextLTPro-BlackItalic.ttf?448e53016abae5d962c35e2ca27adc26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BlackItalic.ttf
// module id = 1447
// module chunks = 0